import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "activities scroll-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "activity"
}
const _hoisted_3 = { class: "activity-info" }
const _hoisted_4 = { class: "activity-link" }
const _hoisted_5 = { class: "activity-date" }
const _hoisted_6 = { class: "activity-info" }
const _hoisted_7 = { class: "activity-link" }
const _hoisted_8 = { class: "badge-wrapper" }
const _hoisted_9 = { class: "activity-date" }
const _hoisted_10 = {
  key: 1,
  class: "activity"
}
const _hoisted_11 = { class: "activity-info" }
const _hoisted_12 = { class: "activity-link name" }
const _hoisted_13 = { class: "activity-link" }
const _hoisted_14 = { class: "activity-date" }
const _hoisted_15 = {
  key: 1,
  class: "muted-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-title-bold" }, "Recent activity", -1)),
    ($setup.getChangedActions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getChangedActions, (action) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterActions(action.changedParams), (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (field === 'status')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (!action.previousLotStatus && action.newLotStatus === $setup.LotStatus.AVAILABLE)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_3, [
                                _cache[0] || (_cache[0] = _createTextVNode("The Contract form for", -1)),
                                _createVNode(_component_router_link, {
                                  class: "lot-link",
                                  to: { name: 'LotActions', params: { stageId: action.stageId, lotId: action.lotId } }
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(` Lot ${action.lotTitle} `), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _cache[1] || (_cache[1] = _createTextVNode("was withdrawn", -1))
                              ]),
                              _createElementVNode("div", _hoisted_5, _toDisplayString($setup.formatDate(action.createdAt)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_router_link, {
                                  class: "lot-link",
                                  to: { name: 'LotActions', params: { stageId: action.stageId, lotId: action.lotId } }
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(`Lot ${action.lotTitle} `), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["badge badge-first", $setup.getDisplayStatusClass(action.previousLotStatus)])
                                  }, _toDisplayString(action.previousLotStatus === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : action.previousLotStatus), 3),
                                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "activity-text" }, "➔", -1)),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["badge", $setup.getDisplayStatusClass(action.newLotStatus)])
                                  }, _toDisplayString(action.newLotStatus === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : action.newLotStatus), 3)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_9, _toDisplayString($setup.formatDate(action.createdAt)), 1)
                            ], 64))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_router_link, {
                            class: "name-link",
                            to: { name: 'ContactDetails', params: { id: action.applicantDetails.customerId } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(`${action.applicantDetails.firstName} ${action.applicantDetails.lastName}`), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "activity-text" }, " sent ", -1)),
                          _createVNode(_component_router_link, {
                            to: { name: 'EOIDetails', params: { id: action.applicantDetails.eoiId } }
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("span", { class: "activity-link" }, "Contract form ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "activity-text" }, "for ", -1)),
                          _createVNode(_component_router_link, {
                            to: { name: 'LotActions', params: { stageId: action.stageId, lotId: action.lotId } }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, "Lot " + _toDisplayString(action.lotTitle), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.formatDate(action.createdAt)), 1)
                      ]))
                ], 64))
              }), 256))
            ], 64))
          }), 256))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_15, "You have no activity for the last 5 days"))
  ]))
}